"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconHd = void 0;
var React = __importStar(require("react"));
var IconHd = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M15.7934,15.1308488 C18.3754,15.1308488 19.4844,13.2639183 19.4534,11.42469 C19.4344,9.6121745 18.3364,7.82637188 15.7934,7.82637188 L12.6644,7.82637188 L12.6644,15.1308488 L15.7934,15.1308488 Z M11.5314,15.1308488 L11.5314,7.82637188 L9.7344,7.82637188 L9.7344,10.7252094 L6.6484,10.7252094 L6.6484,7.82637188 L4.8524,7.82637188 L4.8524,15.1308488 L6.6484,15.1308488 L6.6484,12.3873415 L9.7344,12.3873415 L9.7344,15.1308488 L11.5314,15.1308488 Z M19.9654,4.0005 C21.0824,4.0005 22.0004,4.90873646 22.0004,6.01385642 L22.0004,18.0257288 C22.0004,19.1308488 21.0824,20.0005 19.9654,20.0005 L4.0084,20.0005 C2.8954,20.0005 2.0004,19.1308488 2.0004,18.0257288 L2.0004,6.01385642 C2.0004,4.90873646 2.8954,4.0005 4.0084,4.0005 L19.9654,4.0005 Z M15.7934,9.52708917 C17.1214,9.52708917 17.6174,10.4936981 17.6484,11.4326049 C17.6804,12.4219692 17.1954,13.4301315 15.7934,13.4301315 L14.5004,13.4301315 L14.5004,9.52708917 L15.7934,9.52708917 Z" }))); };
exports.IconHd = IconHd;
exports.IconHd.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconHd;
